import ISelectItem from "./ISelectItem";

export default interface IAPICredentials {
  APIBaseURL: string;
  Key: string;
  Secret: string;
  AuthType: string;
}

export interface IAPIResponse {
  CurlText: string;
  StatusCode: number;
  Errors: string[];
}

export const AuthOptions: ISelectItem[] = [{ Name: "OAuth1" }, { Name: "OAuth2" }];
